module.exports = __webpack_public_path__ + "assets/img/minecraft_world_cube.f138b308.png";